import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import App from './App';
import { buildMsalConfig } from './services/authConfig';
import { loadPublicRuntimeConfig } from './services/runtimeConfig';
import './index.css';

loadPublicRuntimeConfig()
  .then((config) => {
    const msalInstance = new PublicClientApplication(buildMsalConfig(config));

    return msalInstance.initialize().then(() => {
      ReactDOM.createRoot(document.getElementById('root')!).render(
        <React.StrictMode>
          <App pca={msalInstance} config={config} />
        </React.StrictMode>
      );
    });
  })
  .catch((error) => {
    console.error('MSAL initialization failed:', error);
    const root = document.getElementById('root');
    if (root) {
      root.innerHTML =
        '<div style="display:flex;align-items:center;justify-content:center;min-height:100vh;font-family:sans-serif">' +
        '<div style="text-align:center"><h1>Authentication Error</h1>' +
        '<p>Failed to initialize authentication. Please refresh the page or contact support.</p></div></div>';
    }
  });
